/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { Constants } from '../../core/Constants';
import { Document } from '../../core/models/Document';
import { Oas30Operation } from '../../openapi/v3/models/Oas30Operation';
import { Oas30RequestBody } from '../../openapi/v3/models/Oas30RequestBody';
import { DeleteNodeCommand } from './DeleteNodeCommand';
import { Node } from '../../core/models/Node';
import { NodePath } from '../../core/models/NodePath';

/**
 * A command used to delete an operation.
 * 
 * @author eric.wittmann@gmail.com
 * @extends DeleteNodeCommand
 * @class
 */
export class DeleteRequestBodyCommand extends DeleteNodeCommand<Oas30RequestBody> {
    public constructor(operation? : any) {
        if(((operation != null && operation instanceof <any>Oas30Operation) || operation === null)) {
            let __args = arguments;
            super(Constants.PROP_REQUEST_BODY, operation);
        } else if(operation === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.DeleteNodeCommand#readNode(io.apicurio.datamodels.core.models.Document,
     * java.lang.Object)
     * @param {Document} doc
     * @param {*} node
     * @return {Oas30RequestBody}
     */
    readNode(doc : Document, node : any) : Oas30RequestBody {
        let operation : Oas30Operation = <Oas30Operation>this._parentPath.resolve(doc);
        let requestBody : Oas30RequestBody = operation.createRequestBody();
        Library.readNode(node, requestBody);
        return requestBody;
    }
}
DeleteRequestBodyCommand["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteRequestBodyCommand";
DeleteRequestBodyCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




